import React from 'react';

const ColorPickerPreview = props => {

    const handleClick = () => {
        props.setDisplayPicker(!props.displayPicker)
    };

    const style = {
        circleDiv: {
            borderRadius: '50%',
            height: '2em',
            width: '2em',
            cursor: 'pointer',
            border: 'solid 2px #000000',
            backgroundColor: props.color
        },
    }
    return (
        <div data-tip={props.dataTip} style={{ padding: ".5em" }}>
            <div style={style.circleDiv} onClick={handleClick} />
        </div>
    );
}

export default ColorPickerPreview;